import axios from '@/axios'

interface DateFilter {
    start_date?: string
    end_date?: string
    document_type?: string
    document_subtype?: string
}

class AnalyticsDataService {
    async getDocumentAnalytics(filters?: DateFilter): Promise<any> {
        const params = new URLSearchParams()
        if (filters?.start_date) params.append('start_date', filters.start_date)
        if (filters?.end_date) params.append('end_date', filters.end_date)
        if (filters?.document_type) params.append('document_type', filters.document_type)
        if (filters?.document_subtype) params.append('document_subtype', filters.document_subtype)

        const queryString = params.toString()
        return axios.get(`/analytics/documents${queryString ? '?' + queryString : ''}`)
    }

    async getDocumentsByCompany(page = 1, filters?: DateFilter): Promise<any> {
        const params = new URLSearchParams()
        params.append('page', page.toString())
        if (filters?.start_date) params.append('start_date', filters.start_date)
        if (filters?.end_date) params.append('end_date', filters.end_date)
        if (filters?.document_type) params.append('document_type', filters.document_type)
        if (filters?.document_subtype) params.append('document_subtype', filters.document_subtype)

        return axios.get(`/analytics/documents-by-company?${params.toString()}`)
    }

    async getDocumentTypeDistribution(filters?: DateFilter): Promise<any> {
        const params = new URLSearchParams()
        if (filters?.start_date) params.append('start_date', filters.start_date)
        if (filters?.end_date) params.append('end_date', filters.end_date)

        const queryString = params.toString()
        return axios.get(`/analytics/document-types${queryString ? '?' + queryString : ''}`)
    }

    async getDocumentTypes(): Promise<any> {
        return axios.get('/analytics/types')
    }

    async getDocumentSubtypes(): Promise<any> {
        return axios.get('/analytics/subtypes')
    }
}

export default new AnalyticsDataService()
